// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__2cfeD","wrapper":"styles_wrapper__4W4pX","title":"styles_title__6ee5K"};